import { connect } from 'react-redux';

import {
  getPullRequestList,
  getPullRequests,
} from 'src/redux/pull-request-list';
import { BucketState } from 'src/types/state';

import { PullRequestListWithKeyboardShortcuts } from '../components/pull-request-list-with-keyboard-shortcuts';

const mapStateToProps = (state: BucketState) => {
  const { isLoading, isError, isPreRequestState, exception } =
    getPullRequestList(state);
  const pullRequests = getPullRequests(state);

  return {
    isLoading,
    isError,
    pullRequests,
    isPreRequestState,
    exception,
  };
};

export default connect(mapStateToProps)(PullRequestListWithKeyboardShortcuts);
